import FieldType from "@/utils/constants/FieldType.ts";
import MetaData from "@/utils/common/MetaData.ts";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import AGGridEditViewTextColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewTextColumn.ts";
import AGGridEditViewBooleanColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewBooleanColumn.ts";
import AGGridEditViewPasswordColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewPasswordColumn.ts";
import AGGridEditViewMultiChoiceColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewMultiChoiceColumn.ts";
import AGGridEditViewReferenceColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewReferenceColumn.ts";
import SecurityUtils from "@/utils/login/SecurityUtils.ts";
import DomainBaseEntities from "@/utils/constants/DomainBaseEntities.ts";
import AGGridEditViewGenericReferenceColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewGenericReferenceColumn.ts";
import AGGridEditViewFieldIdColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewFieldIdColumn.ts";
import AGGridEditViewIconColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewIconColumn.ts";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import IdsAndConstants from "@/utils/UIConstants/IdsAndConstants.ts";
import AGGridEditViewListCellColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewListCellColumn.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import AGGridEditViewColorPickerColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewColorPickerColumn.ts";
import AGGridEditViewAttachmentColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewAttachmentColumn.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;
import FieldMetaData = namaTypes.FieldMetaData;

export default class AGGridEditViewColumnFactory
{
  static createColDefForType(column: EditScreenGridColumn, handler: EditableGridHandler): AbsAGGridEditViewColumn | null {
    let columnMetadata: FieldMetaData = MetaData.findFieldMetadata(column.id!, handler.metadata);
    switch (columnMetadata.fieldType) {
      case FieldType.Link:
      case FieldType.Email:
      case FieldType.Text:
      case FieldType.BigText:
      case FieldType.LongToken:
      case FieldType.LatLng:
      case FieldType.Decimal:
      case FieldType.Integer:
      case FieldType.Long:
      case FieldType.PhoneNumber:
      case FieldType.Measures:
      case FieldType.Date:
      case FieldType.DateAndTime:
      case FieldType.Time:
        if (ObjectChecker.isAnyEqualToFirst(columnMetadata.fieldId, IdsAndConstants.details_specificDimensions_serialNumber,
          IdsAndConstants.details_specificDimensions_secondSerial)) {
          return new AGGridEditViewListCellColumn(column, handler);
        } else if ((columnMetadata.id ?? "").endsWith(".iconCode")) {
          return new AGGridEditViewIconColumn(column, handler);
        } else if (ClientCache.isFieldValuesRestricted(handler.entityType, columnMetadata.fieldId!)) {
          columnMetadata.allowedValues = ClientCache.getAllowedValuesFor(handler.entityType, columnMetadata.fieldId!);
          return new AGGridEditViewMultiChoiceColumn(column, handler);
        } else {
          let fieldStyle = ClientCache.getFieldStyle(handler.entityType, columnMetadata.fieldId!);
          if (fieldStyle && fieldStyle.showAsPassword)
            return new AGGridEditViewPasswordColumn(column, handler);
          return new AGGridEditViewTextColumn(column, handler);
        }
      case FieldType.Password:
        return new AGGridEditViewPasswordColumn(column, handler);
      case FieldType.Boolean:
        return new AGGridEditViewBooleanColumn(column, handler);
      case FieldType.Reference:
        if (SecurityUtils.isUserLimitedToASingleLegalEntity() && DomainBaseEntities.LegalEntity === columnMetadata.referencedEntityType)
          return null;
        else if (!SecurityUtils.userCanFeature(columnMetadata.referencedEntityType))
          return null;
        return new AGGridEditViewReferenceColumn(column, handler);
      case FieldType.Enum:
      case FieldType.EntityType:
      case FieldType.FeatureID:
        return new AGGridEditViewMultiChoiceColumn(column, handler);
      case FieldType.Genericreference:
        return new AGGridEditViewGenericReferenceColumn(column, handler);
      case FieldType.FieldID:
        return new AGGridEditViewFieldIdColumn(column,handler);
      case FieldType.Color:
        return new AGGridEditViewColorPickerColumn(column, handler);
      case FieldType.Binary:
        return new AGGridEditViewAttachmentColumn(column, handler);
      default:
        return null;
    }
  }
}
